export default __webpack_public_path__ + "static/media/02.ad8bfc63.jpg";